export default () => (
  <svg
    width="24"
    height="25"
    viewBox="0 0 24 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M13.8232 4.88086C14.3488 4.37364 15.1965 4.37407 15.7217 4.88086L19.6025 8.62598C20.1345 9.13968 20.1344 9.97845 19.6025 10.4922L15.7217 14.2373C15.1963 14.744 14.3486 14.7441 13.8232 14.2373C13.2913 13.7236 13.2913 12.8848 13.8232 12.3711L15.376 10.873H10.3379C8.3152 10.8731 6.69649 12.4517 6.69629 14.374C6.69655 16.2963 8.31513 17.8759 10.3379 17.876H17.5439C18.2765 17.876 18.8926 18.4527 18.8926 19.1895C18.8923 19.926 18.2764 20.5029 17.5439 20.5029H10.3379C6.84981 20.5029 4.00026 17.7701 4 14.374C4.00009 10.9778 6.84973 8.24517 10.3379 8.24512H15.376L13.8232 6.74707C13.2911 6.23343 13.2914 5.39468 13.8232 4.88086Z"
      fill="currentColor"
    />
  </svg>
);
